module.exports = __webpack_public_path__ + "static/media/Dance.3c981470.JPG";